"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownCustom = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
const __1 = require("..");
const DropdownCustom = props => {
    const { label, placeholder, selectedLabel = '', errorText, appearance, onChange, disabled, onTouch, value, inputTextAppearance, children } = props;
    const [showOption, setShowOption] = (0, react_1.useState)(false);
    const dropdownRef = (0, react_1.useRef)(null);
    const [labelValue, setLabelValue] = (0, react_1.useState)(undefined);
    /** Change dropdown status */
    const toggleShowOption = () => {
        setShowOption(!showOption);
        onTouch && showOption && onTouch();
    };
    const errorShouldBeVisible = Boolean(appearance === 'error' && errorText);
    const textInputStyle = inputTextAppearance
        ? inputTextAppearance
        : {
            appearance: __1.TokenTextAppearance.headline200,
            style: {
                color: __1.TokenTextColor.primary,
                fontSize: __1.TextSize.TextSize14,
                lineHeight: __1.TextLineHeight.TextLineHeight24
            }
        };
    /**
     * Handle dropdown change event
     * @param value
     */
    const handleDropdownChange = (value, label, touch) => {
        const selectedOption = { value, label };
        setShowOption(false);
        setLabelValue(selectedOption);
        value && onChange(selectedOption, touch);
    };
    /**
     * Hide dropdown option box when user is interacting with another component
     * @param event
     */
    const handleMouseDown = (event) => {
        var _a;
        !((_a = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) && setShowOption(false);
    };
    (0, react_1.useEffect)(() => {
        if (typeof window !== 'undefined') {
            document.addEventListener('mousedown', handleMouseDown, false);
        }
        return () => {
            if (typeof window !== 'undefined') {
                document.removeEventListener('mousedown', handleMouseDown, false);
            }
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if ((labelValue === null || labelValue === void 0 ? void 0 : labelValue.value) !== (value === null || value === void 0 ? void 0 : value.value)) {
            handleDropdownChange(value === null || value === void 0 ? void 0 : value.value, value === null || value === void 0 ? void 0 : value.label, false);
        }
    }, [value]);
    return (react_1.default.createElement(styled_1.StyledDropdown, { ref: dropdownRef, appearance: appearance, disabled: disabled, className: "dropdown-container" },
        react_1.default.createElement(styled_1.DropdownInput, { className: "dropdown-input" },
            label && (react_1.default.createElement(__1.Text, { appearance: __1.TokenTextAppearance.label100, color: __1.TokenTextColor.inherit }, label)),
            react_1.default.createElement(styled_1.StyledLabel, { onClick: toggleShowOption, disabled: disabled, className: "dropdown-label" },
                react_1.default.createElement(styled_1.StyledLabelText, { className: "dropdown-label-text" },
                    react_1.default.createElement(__1.TextCustom, Object.assign({}, textInputStyle), (labelValue === null || labelValue === void 0 ? void 0 : labelValue.label) ? selectedLabel + labelValue.label : placeholder)),
                react_1.default.createElement(styled_1.StyledIcon, { className: `dropdown-icon  ${showOption && 'active'}` },
                    react_1.default.createElement("div", { className: `animation ${showOption && 'active'}` },
                        react_1.default.createElement(__1.ChevronDown, null))))),
        !showOption && errorShouldBeVisible && (react_1.default.createElement(styled_1.StyledErrorText, { role: "alert", className: "dropdown-error" }, errorShouldBeVisible && errorText)),
        showOption && (react_1.default.createElement(styled_1.StyledDropdownBoxWrapper, { className: "dropdown-options-content" },
            react_1.default.createElement(styled_1.StyledDropdownBox, null, children.map((child) => (react_1.default.createElement(styled_1.StyledDropdownBoxOption, { className: "dropdown-option-wrapper", key: child.key || 'child-key', onClick: handleDropdownChange.bind(null, child.props.value, child.props.label, true) }, child))))))));
};
exports.DropdownCustom = DropdownCustom;
__exportStar(require("./dropdown-option"), exports);
